function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function t() {
  return ("undefined" != typeof window ? window : void 0) || function () {
    if ("undefined" != typeof ServiceWorkerGlobalScope && self instanceof ServiceWorkerGlobalScope) return self;
  }();
}
function n() {
  var n;
  return null === (n = t()) || void 0 === n ? void 0 : n.performance;
}
var e = (i = null === (o = null === (r = t()) || void 0 === r ? void 0 : r.navigator) || void 0 === o ? void 0 : o.connection, function () {
  if (i) return {
    type: i.type,
    effectiveType: i.effectiveType,
    saveData: i.saveData
  };
});
var i, r, o;
var s = (c = function () {
  var n;
  return null === (n = t()) || void 0 === n ? void 0 : n.navigator;
}(), function () {
  if (void 0 !== (null == c ? void 0 : c.deviceMemory)) return {
    memory: c.deviceMemory
  };
});
var c;
var a = (u = n(), function () {
  if (u) return {
    mark: function mark(t) {
      u.mark && u.mark(t);
    },
    measure: function measure(t, n, e) {
      u.measure && u.measure(t, n, e);
    },
    now: function now() {
      return u.now ? u.now() : -1;
    },
    clearMarks: function clearMarks(t) {
      u.clearMarks && u.clearMarks(t);
    },
    getEntriesByName: function getEntriesByName(t, n) {
      return u.getEntriesByName ? u.getEntriesByName(t, n) : [];
    }
  };
});
var u, d;
!function (t) {
  t.UNINITIALIZED = "UNINITIALIZED", t.RUNNING = "RUNNING", t.STOPPED = "STOPPED";
}(d || (d = {}));
var f = function (t) {
  return function (n) {
    var e = -1,
      i = d.UNINITIALIZED,
      r = function r() {},
      o = function o() {};
    var _ref = function (t) {
        var n = Math.floor(1e6 * Math.random()),
          e = "".concat(h(t), "-").concat(n),
          i = "".concat(v(t), "-").concat(n),
          r = "".concat(l(t), "-").concat(n);
        return {
          traceStartMark: e,
          traceEndMark: i,
          traceMeasure: r
        };
      }(n),
      s = _ref.traceStartMark,
      c = _ref.traceEndMark,
      a = _ref.traceMeasure,
      u = function u() {
        return {
          duration: e,
          marks: {
            start: s,
            end: c,
            measure: a
          },
          state: f(),
          success: -1 !== e
        };
      },
      f = function f() {
        return i;
      };
    return {
      start: function start() {
        t && i === d.UNINITIALIZED && (t.mark(s), i = d.RUNNING, o(u()));
      },
      stop: function stop() {
        if (!t || i !== d.RUNNING) return u();
        i = d.STOPPED, t.mark(c), t.measure(a, s, c), e = function () {
          var n;
          var e = null == t ? void 0 : t.getEntriesByName(a)[0];
          return null !== (n = null == e ? void 0 : e.duration) && void 0 !== n ? n : -1;
        }();
        var n = u();
        return r(n), n;
      },
      onStart: function onStart(t) {
        o = t;
      },
      onStop: function onStop(t) {
        r = t;
      },
      get: u,
      state: f,
      clear: function clear() {
        t && i === d.STOPPED && (t.clearMarks(s), t.clearMarks(c));
      }
    };
  };
}(a());
var h = function h(t) {
    return "trace-start/".concat(t);
  },
  v = function v(t) {
    return "trace-end/".concat(t);
  },
  l = function l(t) {
    return "trace-measure/".concat(t);
  };
var m = /*#__PURE__*/function () {
  function m(t, n, e, i, r) {
    _classCallCheck(this, m);
    this.createTrace = t, this.t = n, this.i = e, this.o = i, this.longTaskCollector = r, this.traces = {}, this.callback = function () {}, this.u = function (t) {
      return t <= 50 ? "good" : t > 100 ? "poor" : "moderate";
    };
  }
  return _createClass(m, [{
    key: "onMeasure",
    value: function onMeasure(t) {
      this.callback = t;
    }
  }, {
    key: "start",
    value: function start(t) {
      this.traces[t] || (this.traces[t] = this.createTrace(t), this.traces[t].start(), this.longTaskCollector.start());
    }
  }, {
    key: "stop",
    value: function stop(t) {
      if (!this.traces[t]) return;
      var n = this.traces[t],
        e = n.stop();
      e.success && this.callback({
        name: t,
        value: e.duration,
        bucket: "none",
        connection: this.i(),
        device: this.o(),
        longTaskMonitor: this.longTaskCollector.stop()
      }), n.clear(), delete this.traces[t];
    }
  }, {
    key: "eventIdleTime",
    value: function eventIdleTime(t, n) {
      var e = this.t();
      if (!e) return;
      var i = e.now();
      if (-1 !== i) {
        var _e = i - n.timeStamp;
        this.callback({
          name: "event-idle-time",
          value: _e,
          bucket: this.u(_e),
          element: t,
          connection: this.i(),
          device: this.o()
        });
      }
    }
  }]);
}();
var p = /*#__PURE__*/function () {
  function p(t, n) {
    var _this = this;
    _classCallCheck(this, p);
    this.self = t, this.performance = n, this.startTime = -1, this.totalTime = 0, this.longTasks = [];
    var e = null == t ? void 0 : t.PerformanceObserver;
    if (e) try {
      this.performanceObserver = new e(function (t) {
        for (var n = t.getEntries(), e = 0; e < n.length; e++) {
          var _t = n[e];
          _this.totalTime += _t.duration, _this.longTasks.push(_t);
        }
      });
    } catch (t) {}
  }
  return _createClass(p, [{
    key: "collect",
    value: function collect() {
      var _this2 = this;
      return Object.freeze({
        startTime: this.startTime,
        totalTime: this.totalTime,
        longTasks: this.longTasks.map(function (t) {
          return {
            duration: t.duration,
            relativeStartTime: t.startTime - _this2.startTime
          };
        })
      });
    }
  }, {
    key: "start",
    value: function start() {
      var t = this.performance;
      if (!this.performanceObserver || !t || this.startTime > 0) return !1;
      try {
        return this.performanceObserver.observe({
          type: "longtask"
        }), this.startTime = t.now(), !0;
      } catch (t) {
        return !1;
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      var t;
      if (this.startTime < 0) return;
      var n = this.collect();
      return this.longTasks = [], this.startTime = -1, this.totalTime = 0, null === (t = this.performanceObserver) || void 0 === t || t.disconnect(), n;
    }
  }]);
}();
var w,
  y,
  k = function k() {
    return "".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12);
  },
  T = function T(t) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1;
    return {
      name: t,
      value: n,
      delta: 0,
      entries: [],
      id: k(),
      isFinal: !1
    };
  },
  g = function g(t, n) {
    try {
      if (PerformanceObserver.supportedEntryTypes.includes(t)) {
        var e = new PerformanceObserver(function (t) {
          return t.getEntries().map(n);
        });
        return e.observe({
          type: t,
          buffered: !0
        }), e;
      }
    } catch (t) {}
  },
  S = !1,
  M = !1,
  b = function b(t) {
    S = !t.persisted;
  },
  N = function N() {
    addEventListener("pagehide", b), addEventListener("beforeunload", function () {});
  },
  E = function E(t) {
    var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    M || (N(), M = !0), addEventListener("visibilitychange", function (n) {
      var e = n.timeStamp;
      "hidden" === document.visibilityState && t({
        timeStamp: e,
        isUnloading: S
      });
    }, {
      capture: !0,
      once: n
    });
  },
  I = function I(t, n, e, i) {
    var r;
    return function () {
      e && n.isFinal && e.disconnect(), n.value >= 0 && (i || n.isFinal || "hidden" === document.visibilityState) && (n.delta = n.value - (r || 0), (n.delta || n.isFinal || void 0 === r) && (t(n), r = n.value));
    };
  },
  L = function L() {
    return void 0 === w && (w = "hidden" === document.visibilityState ? 0 : 1 / 0, E(function (t) {
      var n = t.timeStamp;
      return w = n;
    }, !0)), {
      get timeStamp() {
        return w;
      }
    };
  },
  P = function P() {
    return y || (y = new Promise(function (t) {
      return ["scroll", "keydown", "pointerdown"].map(function (n) {
        addEventListener(n, t, {
          once: !0,
          passive: !0,
          capture: !0
        });
      });
    })), y;
  };
var $ = {
  CLS: [.1, .25],
  FCP: [1e3, 2500],
  FID: [100, 300],
  LCP: [2500, 4e3],
  TTFB: void 0
};
var C = /*#__PURE__*/function () {
  function C(t, n) {
    var _this3 = this;
    _classCallCheck(this, C);
    this.i = t, this.o = n, this.callback = function () {}, this.reportHandler = function (t) {
      _this3.callback({
        name: t.name.toLowerCase(),
        value: t.value,
        bucket: _this3.h(t),
        connection: _this3.i(),
        device: _this3.o()
      });
    }, this.h = function (t) {
      var n = $[t.name];
      return n ? t.value <= n[0] ? "good" : t.value > n[1] ? "poor" : "moderate" : "none";
    };
  }
  return _createClass(C, [{
    key: "setupObservers",
    value: function setupObservers(t) {
      return this.callback = t, function (t) {
        var n,
          e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          i = T("CLS", 0),
          r = function r(t) {
            t.hadRecentInput || (i.value += t.value, i.entries.push(t), n());
          },
          o = g("layout-shift", r);
        o && (n = I(t, i, o, e), E(function (t) {
          var e = t.isUnloading;
          o.takeRecords().map(r), e && (i.isFinal = !0), n();
        }));
      }(this.reportHandler), function (t) {
        var n,
          e = T("FCP"),
          i = L(),
          r = g("paint", function (t) {
            "first-contentful-paint" === t.name && t.startTime < i.timeStamp && (e.value = t.startTime, e.isFinal = !0, e.entries.push(t), n());
          });
        r && (n = I(t, e, r));
      }(this.reportHandler), function (t) {
        var n = T("FID"),
          e = L(),
          i = function i(t) {
            t.startTime < e.timeStamp && (n.value = t.processingStart - t.startTime, n.entries.push(t), n.isFinal = !0, o());
          },
          r = g("first-input", i),
          o = I(t, n, r);
        r ? E(function () {
          r.takeRecords().map(i), r.disconnect();
        }, !0) : window.perfMetrics && window.perfMetrics.onFirstInputDelay && window.perfMetrics.onFirstInputDelay(function (t, i) {
          i.timeStamp < e.timeStamp && (n.value = t, n.isFinal = !0, n.entries = [{
            entryType: "first-input",
            name: i.type,
            target: i.target,
            cancelable: i.cancelable,
            startTime: i.timeStamp,
            processingStart: i.timeStamp + t
          }], o());
        });
      }(this.reportHandler), function (t) {
        var n,
          e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          i = T("LCP"),
          r = L(),
          o = function o(t) {
            var e = t.startTime;
            e < r.timeStamp ? (i.value = e, i.entries.push(t)) : i.isFinal = !0, n();
          },
          s = g("largest-contentful-paint", o);
        if (s) {
          n = I(t, i, s, e);
          var c = function c() {
            i.isFinal || (s.takeRecords().map(o), i.isFinal = !0, n());
          };
          P().then(c), E(c, !0);
        }
      }(this.reportHandler), function (t) {
        var n,
          e = T("TTFB");
        n = function n() {
          try {
            var n = performance.getEntriesByType("navigation")[0] || function () {
              var t = performance.timing,
                n = {
                  entryType: "navigation",
                  startTime: 0
                };
              for (var e in t) "navigationStart" !== e && "toJSON" !== e && (n[e] = Math.max(t[e] - t.navigationStart, 0));
              return n;
            }();
            e.value = e.delta = n.responseStart, e.entries = [n], e.isFinal = !0, t(e);
          } catch (t) {}
        }, "complete" === document.readyState ? setTimeout(n, 0) : addEventListener("pageshow", n);
      }(this.reportHandler), this;
    }
  }]);
}();
function F(i) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!r.serviceWorkerSupport) {
    new C(e, s).setupObservers(i);
  }
  var o = new p(t(), n()),
    c = new m(f, a, e, s, o);
  return c.onMeasure(i), {
    start: function start(t) {
      c.start(t);
    },
    stop: function stop(t) {
      c.stop(t);
    },
    eventIdleTime: function eventIdleTime(t, n) {
      c.eventIdleTime(t, n);
    }
  };
}
var D = function D() {
    return window.RUM_INPUT_LATENCY_TRACES || new Map();
  },
  O = function O(t, n) {
    var i = t.id,
      r = t.trace,
      o = t.disconnect,
      c = t.clickCount;
    if ("RUNNING" === r.state()) {
      var _r$stop = r.stop(),
        _t2 = _r$stop.duration;
      n({
        name: "input-latency",
        value: _t2,
        bucket: "none",
        inputName: i,
        clickCount: c,
        connection: e(),
        device: s()
      }), r.clear();
    }
    o();
  },
  G = function G(t) {
    D().forEach(function (n) {
      O(n, t);
    });
  };
export { f as createTrace, D as getInputLatencyTraces, F as rum, G as trackAllInputLatencies, O as trackInputLatency };